import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowLeft } from '@outdoor-voices/ui';
import { useQuery } from 'urql';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { QUERY } from './queries';
import { REVIEWS } from '../../apps/product/QuestionsAndReviews/constants';
import allCss from './ReviewsAll.module.scss';
import css from '../Reviews/Reviews.module.scss';
import Reviews from '../Reviews';
import Spinner from '../icons/Spinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ReviewsAll = function ReviewsAll(_ref) {
  var filterByPhotos = _ref.filterByPhotos,
      shopifyId = _ref.shopifyId;

  var _useQuery = useQuery({
    query: QUERY,
    variables: {
      shopifyId: shopifyId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      error = _useQuery2$.error,
      fetching = _useQuery2$.fetching;

  if (fetching) {
    return /*#__PURE__*/_jsxs("div", {
      "aria-busy": "true",
      className: cc([allCss.root, allCss.fetching]),
      id: REVIEWS.id,
      children: [/*#__PURE__*/_jsx("header", {
        className: cc([allCss.header]),
        children: /*#__PURE__*/_jsx("h1", {
          className: allCss.title,
          children: "\xA0"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: css.spinner,
        children: /*#__PURE__*/_jsx(Spinner, {})
      })]
    });
  }

  if (error) {
    console.error('ReviewsAll error: ', error);
  }

  if (!(data !== null && data !== void 0 && data.product) || error) {
    return false;
  }

  var product = data.product;
  var properties = product.properties;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([allCss.root, _defineProperty({}, css.fetching, fetching)]),
    id: REVIEWS.id,
    children: [/*#__PURE__*/_jsx("div", {
      className: cc([css.wrap, css.root]),
      children: /*#__PURE__*/_jsxs("header", {
        className: cc([allCss.header]),
        children: [/*#__PURE__*/_jsxs("h1", {
          className: allCss.title,
          children: [product.title, /*#__PURE__*/_jsx("div", {
            className: allCss.subtitle,
            children: "Reviews"
          })]
        }), product.absoluteUrl && /*#__PURE__*/_jsx("div", {
          className: allCss.divider,
          children: /*#__PURE__*/_jsxs("a", {
            className: allCss.returnLink,
            href: product.absoluteUrl,
            children: [/*#__PURE__*/_jsx(ArrowLeft, {}), "Back to Product"]
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Reviews, _objectSpread(_objectSpread(_objectSpread({}, properties), product), {}, {
      filterByPhotos: filterByPhotos,
      shopifyId: shopifyId
    }))]
  });
};

ReviewsAll.defaultProps = {
  filterByPhotos: false
};
ReviewsAll.propTypes = {
  filterByPhotos: PropTypes.bool,
  shopifyId: PropTypes.number.isRequired
};
export default ReviewsAll;